import { HTMLProps, useEffect, useRef } from 'react';

const IndeterminateCheckbox = ({
  indeterminate,
  ...rest
}: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>) => {
  const ref = useRef<HTMLInputElement>(null!);

  useEffect(() => {
    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate]);

  return (
    <input
      type='checkbox'
      ref={ref}
      style={{
        cursor: 'pointer',
        width: 15,
        height: 15,
      }}
      {...rest}
    />
  );
};

export default IndeterminateCheckbox;
